var i = Object.defineProperty, n = Object.defineProperties;
var p = Object.getOwnPropertyDescriptors;
var t = Object.getOwnPropertySymbols;
var c = Object.prototype.hasOwnProperty, l = Object.prototype.propertyIsEnumerable;
var a = (o, e, r) => e in o ? i(o, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : o[e] = r, m = (o, e) => {
  for (var r in e || (e = {}))
    c.call(e, r) && a(o, r, e[r]);
  if (t)
    for (var r of t(e))
      l.call(e, r) && a(o, r, e[r]);
  return o;
}, f = (o, e) => n(o, p(e));
import s, { forwardRef as w } from "react";
import D from "../lib/IconBase.mjs";
import b from "../defs/CaretDoubleDown.mjs";
const d = w((o, e) => /* @__PURE__ */ s.createElement(D, f(m({ ref: e }, o), { weights: b })));
d.displayName = "CaretDoubleDown";
export {
  d as CaretDoubleDown
};
